(function() {
  function updateCardFromVariant(widget, checked) {
  if (!widget || !checked) return;

  var cardSelector = widget.getAttribute('data-card-selector') || '[data-product-card]';
  var cardLinkSelector = widget.getAttribute('data-card-link-selector') || 'a[href]';
  var cardButtonSelector = widget.getAttribute('data-card-button-selector') || '[data-card-atc]';

  var variantId = checked.getAttribute('data-variant-id');
  var variantUrl = checked.getAttribute('data-variant-url');

  if (!variantId || !variantUrl) return;

  var card = widget.closest(cardSelector);
  if (!card) return;

  var link = card.querySelector(cardLinkSelector);
  if (link) {
    link.setAttribute('href', variantUrl);
    link.setAttribute('data-variant-id', variantId);
  }

  var button = card.querySelector(cardButtonSelector);
  if (button) {
    button.setAttribute('data-variant-id', variantId);

  }
}

  function initCardSelectors(root) {
    // root can be document, a section, or any container element
    var widgets = (root || document).querySelectorAll('[data-card-variant-widget]:not([data-card-variant-initialized])');
    if (!widgets.length) return;

    widgets.forEach(function(widget) {
      // Mark as initialized so we don't rebind listeners multiple times
      widget.setAttribute('data-card-variant-initialized', 'true');

      var radios = widget.querySelectorAll('.card-radio');
      var titleEl = widget.querySelector('[data-variant-title]');
      var priceEl = widget.querySelector('[data-card-price]');
      var normalPriceEl = widget.querySelector('[data-card-price-normal]');
      var comparePriceEl = widget.querySelector('[data-card-compare-price]');
      var compareLabelEl = widget.querySelector('[data-card-compare-label]');
      var saleWrapper = widget.querySelector('[data-card-sale-wrapper]');

      widget.querySelectorAll('.card-label').forEach(function(label) {
        label.addEventListener('click', function(event) {
          var linkAncestor = label.closest('a[href]');
          if (linkAncestor) {
            event.stopPropagation();
          }
        });
      });

      function updateFromChecked() {
        var checked = widget.querySelector('.card-radio:checked');

        // Fallback: if nothing is checked, select the first radio
        if (!checked) {
          checked = widget.querySelector('.card-radio');
          if (!checked) return;
          checked.checked = true;
        }

        var title = checked.dataset.title || '';
        var price = checked.dataset.price || '';
        var comparePrice = checked.dataset.comparePrice || '';
        var compareLabel = checked.dataset.compareLabel || '';

        if (titleEl && title) {
          titleEl.textContent = title;
        }

        if (priceEl && price) {
          priceEl.textContent = price;
        }

        if (normalPriceEl && price) {
          normalPriceEl.textContent = price;
        }

        if (comparePriceEl) {
          comparePriceEl.textContent = comparePrice || '';
        }

        if (compareLabelEl && compareLabel) {
          compareLabelEl.textContent = compareLabel;
        }

        var options = widget.querySelectorAll('.card-option');
        options.forEach(function (opt) {
          opt.classList.remove('is-active');
        });

        var activeOption = checked.closest('.card-option');
        if (activeOption) {
          activeOption.classList.add('is-active');
        }

        if (saleWrapper && normalPriceEl) {
          if (comparePrice) {
            saleWrapper.hidden = false;
            normalPriceEl.hidden = true;
          } else {
            saleWrapper.hidden = true;
            normalPriceEl.hidden = false;
          }
        }
        // NEW: sync the parent product card (link + button) with the selected variant
          updateCardFromVariant(widget, checked);
      }

      radios.forEach(function(radio) {
        radio.addEventListener('change', updateFromChecked);
      });

      // Initialize state for this widget
      updateFromChecked();
    });
  }

  // Expose on window so you can call it from other scripts if needed
  window.initCardSelectors = initCardSelectors;

  // Run on initial load
  document.addEventListener('DOMContentLoaded', function () {
    initCardSelectors(document);
  });
})();